module.exports = __webpack_public_path__ + "img/sonic-screwdriver.aa538fdc.jpg";